<template>
  <div
    :class="{'boss-check': check}"
    class="boss-resumecard-item"
  >
    <scout-resume-card-avatar
      :id="memberObject.id"
      :member="memberObject.member"
      :checked="checked"
      :is-scouted="isScouted"
      :is-show-checkbox="isShow"
      :is-scout-decline="isScoutDecline"
      @change="(arg) => $emit('change', arg)"
    />
    <div class="boss-resumecard-item-right">
      <div class="boss-resumecard-details">
        <div class="boss-resumecard-overview clearfix">
          <scout-resume-member-summary
            class="boss-resumecard-overview-title"
            :member="memberObject.member"
          />
          <dl class="boss-resumecard-overview-list">
            <dt class="boss-resumecard-overview-item">
              <span class="boss-resumecard-head">直近の経験職種</span>
            </dt>
            <dd
              class="boss-resumecard-overview-body boss-ellipsis-block"
              data-test="member_experienced_occupation"
            >
              {{ presentOccupation | parseBlankForDefaultValue }}
            </dd>
          </dl>
          <dl class="boss-resumecard-overview-list">
            <dt class="boss-resumecard-overview-item">
              <span class="boss-resumecard-head">希望職種</span>
            </dt>
            <dd
              class="boss-resumecard-overview-body boss-ellipsis-block"
              data-test="member_desired_occupation"
            >
              {{ convertObjectLabel(memberObject.member.desiredOccupations) | parseBlankForDefaultValue }}
            </dd>
          </dl>
          <div class="boss-layout boss-layout-no-gap">
            <dl class="boss-resumecard-overview-list">
              <dt class="boss-resumecard-overview-item">
                <span class="boss-resumecard-head">希望勤務地</span>
              </dt>
              <dd
                class="boss-resumecard-overview-body boss-ellipsis-block"
                data-test="member_desired_work_prefecture"
              >
                {{ convertPrefectureLabel(memberObject.member.desiredWorkPrefectures) | parseBlankForDefaultValue }}
              </dd>
            </dl>
          </div>
          <template v-if="!isScouted">
            <scout-resume-card-detail
              v-if="!isMaskingTarget"
              :member="memberObject.member"
              :comment="comment"
            />
            <div v-else>
              {{ maskingLabel }}
            </div>
          </template>
          <div
            v-if="isScouted"
            class="boss-scout-mail"
          >
            <ul class="boss-scout-status">
              <li
                v-if="scoutTitle"
                class="boss-scout-status-item"
              >
                <div class="boss-ellipsis-block">
                  <span
                    class="boss-scout-status-date"
                    data-test="scout-datetime"
                  >{{ scoutDateTime }}</span>
                  <span
                    class="boss-scout-status-subject"
                    data-test="scout-title"
                  >{{ scoutTitle }}</span>
                </div>
              </li>
              <li
                v-if="scoutedCounts"
                class="boss-scout-status-item boss-send-number"
              >
                <span
                  class="boss-scout-status-text"
                  data-test="scout-count"
                >{{ scoutedCounts }}</span>
              </li>
              <li
                v-if="scoutSpecialFavors && scoutSpecialFavors.length"
                class="boss-scout-status-item boss-scout-bonus"
              >
                <span
                  v-for="(specialFavor, index) in scoutSpecialFavors"
                  :key="index"
                  v-tooltip="{ content: getSpecialFavorTooltip(specialFavor)}"
                  :data-test="'scout-special-favor-' + index"
                  :class="{ 'boss-bonus-end': !specialFavor.isEffective }"
                  class="boss-bonus-check-text boss-check-true"
                >{{ specialFavor.name }}</span>
              </li>
            </ul>
          </div>
          <div
            v-if="memberObject.member.searchConditionName"
            class="boss-scout-status-item"
          >
            <span
              class="boss-scout-status-text"
              data-test="member-search-condition-name"
            >検索条件名：{{ memberObject.member.searchConditionName }}</span>
          </div>
        </div>
        <div class="boss-resumecard-button-list">
          <div class="boss-layout boss-layout-vertical boss-layout-fill">
            <div
              v-if="isExcluded"
              class="resumecard-button-list-list"
            >
              <span
                class="boss-button boss-button-strong boss-button-fill boss-button-small"
                data-test="restore"
                @click="onRestoreClick"
              >
                <span>検索対象に戻す</span>
              </span>
            </div>
            <div
              v-if="showsScoutButton && !isMaskingTarget && canApproach"
              class="resumecard-button-list-list"
            >
              <span
                v-if="isReserved"
                type="button"
                data-test="scout-reserved"
                class="boss-button boss-button-strong boss-button-fill boss-button-small pega-button boss-button-pushed"
              >予約中</span>
              <a
                v-else-if="isScoutInvalid"
                disabled
                type="button"
                data-test="scout-invalid"
                class="boss-button boss-button-strong boss-button-fill boss-button-small pega-button"
              >再送期限切れ</a>
              <a
                v-else
                data-test="scout-create"
                class="boss-button boss-button-strong boss-button-fill boss-button-small"
                @click="$router.push({ name: 'scoutCreate', params: { idAndNameObjects: [ { userId: memberObject.member.id, searchConditionName: searchConditionName}], jobId: jobId, contractId: contractId } })"
              >
                <span class="boss-icon boss-icon-scout boss-button-icon-large" />
                <span>スカウト</span>
              </a>
            </div>
            <div class="resumecard-button-list-list">
              <a
                class="boss-button boss-button-outline boss-button-fill boss-button-small"
                data-open="boss-modal-control"
                data-test="open-detail"
                @click="onReveal"
              >
                <span>詳細を見る</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <scout-member-detail
      :id="memberObject.id"
      :contract-id="contractId"
      :job-id="jobId"
      :show-detail="showDetail"
      :user-id="memberObject.member.id"
      :search-condition-name="searchConditionName"
      :is-show-checked-close-button="isShow"
      :shows-excluded-button="showsExcludedButton"
      :is-scout-decline="isScoutDecline"
      @check-from-child="checkFromChild"
      @update-comment="updateComment"
      @update-member-excluded="updateMemberExcluded"
    />
  </div>
</template>

<script>
import ScoutResumeCardAvatar from '@/components/molecules/ScoutResumeCardAvatar'
import ScoutResumeCardDetail from '@/components/molecules/ScoutResumeCardDetail'
import ScoutResumeMemberSummary from '@/components/atoms/ScoutResumeMemberSummary'
import resumeParseUtils from '@/lib/resumeParseUtils'
import _ from 'lodash'
import ScoutMemberDetail from '@/components/templates/ScoutMemberDetail'
import Foundation from 'foundation-sites'
import jQuery from 'jquery'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'

export default {
  components: { ScoutResumeCardAvatar, ScoutResumeCardDetail, ScoutMemberDetail, ScoutResumeMemberSummary },
  mixins: [resumeParseUtils],
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    memberObject: {
      type: Object,
      required: true
    },
    checked: {
      type: Array,
      default: () => ([])
    },
    isScouted: {
      type: Boolean,
      default: false
    },
    contractId: {
      type: Number,
      default: null
    },
    jobId: {
      type: Number,
      default: null
    },
    isPublishJob: {
      type: Boolean,
      default: false
    },
    searchedConditionName: {
      type: String,
      default: ''
    },
    searchedConditionId: {
      type: Number,
      default: null
    },
    showsScoutButton: {
      type: Boolean,
      default: true
    },
    isExcluded: {
      type: Boolean,
      default: false
    },
    isCandidate: {
      type: Boolean,
      default: false
    },
    showsCheckControl: {
      type: Boolean,
      default: true
    },
    needsCheckControl: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showDetail: false,
      comment: _.defaultTo(_.get(this.memberObject, 'member.approachComment'), '')
    }
  },
  computed: {
    ...mapGetters('contracts', [
      'contracts',
      'canScoutResend'
    ]),
    ...mapGetters({
      specialFavorBy: 'specialFavorBy'
    }),
    check () {
      return _.includes(this.checked, this.memberObject.id)
    },
    presentOccupation () {
      return _.get(this.memberObject.member, 'presentOccupation.name')
    },
    searchConditionName () {
      return this.memberObject.member.searchConditionName ? this.memberObject.member.searchConditionName : _.defaultTo(this.searchedConditionName, '')
    },
    scoutTitle () {
      const title = _.get(this.memberObject.member, 'scout.latestMessage.subject')
      return (title) ? `件名： ${title}` : ''
    },
    scoutDateTime () {
      return _.get(this.memberObject.member, 'scout.latestMessage.insertDate')
        ? dayjs(_.get(this.memberObject.member, 'scout.latestMessage.insertDate')).format('YYYY-MM-DD HH:mm') : ''
    },
    scoutedCounts () {
      const count = _.get(this.memberObject.member, 'scout.messagesCount')
      return (count) ? `送信回数：${count}回` : ''
    },
    scoutSpecialFavors () {
      return _.get(this.memberObject.member, 'scout.specialFavors')
    },
    isScoutInvalid () {
      return this.isScouted && !this.isPublishJob && !this.canScoutResend(this.contractId, this.jobId)
    },
    canApproach () {
      return !this.isScoutExcluded && !this.isEntry &&
      !(this.isScoutDecline && this.canScoutResend(this.contractId, this.jobId))
    },
    isMaskingTarget () {
      return this.isScoutRejection || this.isWithDraw || !this.isUseScout
    },
    maskingLabel () {
      const label = this.isWithDraw ? '退会済み' : '利用停止'
      return `${label}のため表示できません。`
    },
    isReserved () {
      return _.get(this.memberObject, 'member.isScoutReserved')
    },
    isScoutDecline () {
      return _.get(this.memberObject, 'member.isScoutDecline')
    },
    isScoutExcluded () {
      return _.get(this.memberObject, 'member.isScoutExcluded')
    },
    isEntry () {
      return _.get(this.memberObject, 'member.isEntry')
    },
    isScoutRejection () {
      return _.get(this.memberObject, 'member.isScoutRejection')
    },
    isWithDraw () {
      return !!_.get(this.memberObject, 'member.withdrawDate')
    },
    isUseScout () {
      return _.get(this.memberObject, 'member.subscriptions.scout')
    },
    canScoutSent () {
      return this.canApproach &&
        !this.isReserved &&
        !this.isMaskingTarget
    },
    isShow () {
      return this.showsCheckControl && (this.needsCheckControl ? this.canScoutSent : true)
    },
    showsExcludedButton () {
      return !this.isExcluded && !this.isScoutExcluded
    }
  },
  beforeDestroy () {
    jQuery('#boss-modal-control-' + this.memberObject.member.id).parent().remove()
  },
  methods: {
    convertSliceObjectLabel (value, begin, end) {
      if (!value || !value.length) return ''
      return value.slice(begin, end).map(v => {
        return this.getNameOrUndefined(v, 'name')
      }).join('、')
    },
    convertObjectLabel (value) {
      if (!value || !value.length) return ''
      return value.map(v => {
        return this.getNameOrUndefined(v, 'name')
      }).join('、')
    },
    convertPrefectureLabel (value) {
      if (!value || !value.length) return ''
      return value.map(v => {
        const cityLabel = v.cities.map(city => city.name).join('、')
        return cityLabel.length ? `${this.getNameOrUndefined(v, 'name')}(${cityLabel})` : this.getNameOrUndefined(v, 'name')
      }).join('、')
    },
    openReveal () {
      if (!this.modalResumeWindow) {
        this.modalResumeWindow = new Foundation.Reveal(jQuery(`#boss-modal-control-${this.memberObject.member.id}`), {
          // These options can be declarative using the data attributes
          // animationIn: 'scale-in-up'
        })
        this.$set(this, 'showDetail', true)

        // 開く際にスクロール記憶をリセットする設定
        jQuery(`#boss-modal-control-${this.memberObject.member.id}`).on('open.zf.reveal', () => {
          jQuery(`#boss-modal-control-${this.memberObject.member.id}`).scrollTop(0)
        })
      }
      this.modalResumeWindow.open()
    },
    checkFromChild (id) {
      this.$emit('checked', id)
    },
    updateComment (comment) {
      this.comment = comment
    },
    onReveal () {
      this.openReveal()
      if (this.searchedConditionId) {
        this.updateSearchNewResultRead()
      } else if (this.memberObject.member.recommendedId) {
        this.updateRecommendRead()
      }
    },
    updateRecommendRead () {
      if (this.memberObject.member.isNew) {
        this.$http.secured.patch(`scout/view/recommends/${this.memberObject.member.recommendedId}/resume/_is_read`).then((response) => {
          this.memberObject.member.isNew = false
        })
      }
    },
    updateSearchNewResultRead () {
      if (this.memberObject.member.isNew) {
        this.$http.secured.patch(`scout/view/scouts/search_conditions/${this.searchedConditionId}/users/${this.memberObject.member.id}/_is_read`).then((response) => {
          this.memberObject.member.isNew = false
        })
      }
    },
    onRestoreClick () {
      this.$http.secured.delete('/scout/view/company/excluded_users', { data: [this.memberObject.id] }).then(() => {
        this.$emit('fetch')
        this.$toasted.global.success({ message: '検索対象に戻しました。' })
      })
    },
    updateMemberExcluded () {
      _.set(this.memberObject, 'member.isScoutExcluded', true)
      this.check && this.$emit('spliceCheckedMember', this.memberObject.id)
    },
    getSpecialFavorTooltip (specialFavor) {
      return specialFavor.isEffective ? this.specialFavorBy(specialFavor.id).description : '期限切れのため、薄色で表示しています。'
    }
  }
}
</script>
